import DiagramUtils from "../../designer/utils/DiagramUtils";

export default function useDiagramInfo(type) {
    return DiagramUtils.getModelMetadata(type);
}